import Outcome, { REVENUE_OUTCOME_ID } from './Outcome';

/**
 * Builds an outcome for a purchase.
 * 
 * @param value The purchase price for the current outcome.
 */
export function buildRevenueOutcome(value: number): Outcome {
  return { id: REVENUE_OUTCOME_ID, value };
}

/**
 * Util method to determine if the outcome objects are equal.
 * 
 * If either of the objects are undefined, then it will always return false.  Even if both values are undefined.
 * This then will go through and compare the id and values.
 * 
 * @param a Outcome object to compare against.
 * @param b Outcome object to compare against.
 */
export function areOutcomesEqual(a: Outcome | undefined, b: Outcome | undefined): boolean {
  if (!a || !b) {
    return false;
  }

  return a.id === b.id && a.value === b.value;
}
